import React, { useEffect } from "react"

import { FormControl, FormHelperText, FormLabel, Switch } from "@mui/joy";
import { Icon } from '../../assets';
import { useTranslation} from 'react-i18next';

const InputSwitch = (props) => {
    const {t} = useTranslation();

    const {
        editing,
        required,
        name,
        ischecked,
        label,
        autoFocus,
        hint,
        icon,
        haserror,
        checkedlabel,
        uncheckedlabel,
        className = "",
        value,
        onChange,
        error,
    } = props;
    let { readonly, disabled } = props;
    if (!editing) readonly = true;
    if (readonly) disabled = true;

    const [checked, setChecked] = React.useState(ischecked ?? Boolean(value));

    useEffect(() => {
        if (typeof value !== "undefined") {
            setChecked(Boolean(value));
        }
    }, [value]);



    const invalid = Boolean(error);
    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (invalid) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    return (
        <div className={("form-element switch " + className).trim()}>
            <FormControl error={invalid} orientation="horizontal" className={(error) ? generalClass + " form-element-error" : generalClass}>
                {label ? <FormLabel className="form-element-label" htmlFor={name}>{t(label.trim())}</FormLabel> : null}
                <Switch
                    id={name}
                    name={name}
                    checked={checked}
                    value={value}
                    onChange={(event) => {
                        setChecked(event.target.checked);
                        onChange?.(event.target.checked);
                    }}
                    variant="outlined"
                    autoComplete="off"
                    autoFocus={autoFocus}
                    disabled={disabled}
                    readOnly={readonly}
                    required={required}
                    startDecorator={(icon) ? (
                        <Icon icon={icon} />
                    ) : (
                        <></>
                    )}
                    endDecorator={(haserror || error) ? (
                        <>
                            {checked ? t(checkedlabel) : t(uncheckedlabel)}
                            <Icon icon="faCircleExclamation" />
                        </>
                    ) : (
                        <>{checked ? t(checkedlabel) : t(uncheckedlabel)}</>
                    )}
                />
                <FormHelperText className="form-element-hint">
                    {(haserror || error) ? (
                        <>
                            {error ? error.message : 'Messaggio di errore'}
                        </>
                    ) : (
                        <>
                            {hint}
                        </>
                    )}
                </FormHelperText>
            </FormControl>
        </div>
    );
};


export default InputSwitch;
